class DimitoHeaderDrawer extends HTMLElement {
  constructor() {
    super();
    
    this.content = this.querySelector('.dimito-menu--wrap');
    this.dim = document.querySelector('.dim');
    this.searchPopup = document.querySelector('dimito-search-popup');

    this.active = null;
    this.prevBtn = null;
    this.heading = this.querySelectorAll('[data-dimito-menu-heading]');

    this.subActive = null;
    this.subPrevBtn = null;
    this.subHeading = this.querySelectorAll('[data-dimito-submenu-heading]');

    this.menuTrigger();
    this.actionDim();

    this.heading.forEach((heading) =>
      heading.addEventListener('click', this.menuToggle.bind(this))
    );

    this.subHeading.forEach((subHeading) =>
      subHeading.addEventListener('click', this.subMenuToggle.bind(this))
    );

  }

  menuTrigger() {
    document.querySelectorAll('[data-dimito-menu]').forEach((menu) => {
      menu.addEventListener('click', (event) => {
        event.preventDefault();

        if (this.content.classList.contains('on')) {
          this.isClose();
        } else {
          this.isOpen();
        }
      })
    })
  }

  actionDim() {
    this.dim.addEventListener('click', (event) => {
      event.preventDefault();
      this.isClose();
    })
  }

  isOpen() {
    this.content.classList.add('on');
    // document.body.classList.add('overflow-hidden');
    document.querySelector("html").style.overflow = "hidden";
    this.dim.classList.add('on');
    document.querySelectorAll('[data-dimito-menu]').forEach((menu) =>
      menu.classList.add('is-active')
    );
    if (this.searchPopup) this.searchPopup.isClose();
  }

  isClose() {
    this.content.classList.remove('on');
    // document.body.classList.remove('overflow-hidden');
    document.querySelector("html").style.overflow = "auto";
    this.dim.classList.remove('on');
    document.querySelectorAll('[data-dimito-menu]').forEach((menu) =>
      menu.classList.remove('is-active')
    );
  }

  menuToggle(event) {
    event.preventDefault();
   
    const currentBtn = event.currentTarget.closest('[data-dimito-menu-heading]') || event.target;
    const panel = currentBtn.nextElementSibling;
    currentBtn.classList.toggle('on');

    if (this.active) {
      this.active.style.maxHeight = null;
    }

    if (this.prevBtn && this.prevBtn !== currentBtn) {
      this.prevBtn.classList.remove('on');
    }

    if (panel !== this.active) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      this.active = panel;
      this.prevBtn = currentBtn;
    } else {
      this.active = null;
    }

  }

  subMenuToggle(event) {
    event.preventDefault();
   
    const currentBtn = event.currentTarget.closest('[data-dimito-submenu-heading]') || event.target;
    const panelParent = currentBtn.closest('[data-dimito-menu-panel]');
    const panel = currentBtn.nextElementSibling;
    currentBtn.classList.toggle('on');

    if (this.subActive) {
      this.subActive.style.maxHeight = null;
    }

    if (this.subPrevBtn && this.subPrevBtn !== currentBtn) {
      this.subPrevBtn.classList.remove('on');
    }

    if (panel !== this.subActive) {
      panel.style.maxHeight = panel.scrollHeight + 'px';
      panelParent.style.maxHeight = `${parseInt(panelParent.style.maxHeight) + panel.scrollHeight}px`;
      this.subActive = panel;
      this.subPrevBtn = currentBtn;
    } else {
      this.subActive = null;
    }

  }
}

customElements.define('dimito-header-drawer', DimitoHeaderDrawer);
